export const webClientId = '502747862951-blpmic3n0hfpuahfa75d17jg76qprt2b.apps.googleusercontent.com'